import type { ApiError } from "@/lib/api";

export const INDUSTRY_MISSING = "Choose an industry.";

const INDUSTRY_NOT_ACCEPTED =
  "The server does not accept that industry. Choose one from the list, or reload the page if the list looks out of date.";

/**
 * The create endpoint's refusal of the industry, as a line under the field.
 *
 * Two API versions answer differently (verified as of 2026-10-14): one that
 * requires the field answers 400 `INDUSTRY_REQUIRED` or `INDUSTRY_UNKNOWN`;
 * the one before it answers 409 `CREATE_TENANT_FAILED` with a message that
 * starts `Invalid industry "`. Matched on those exactly, never on the word
 * "industry" anywhere in a message: other refusals echo what the admin typed
 * (an org named "Acme Industry", a subdomain, an email), and those must stay
 * the form's general error.
 */
export function industryRefusal(err: ApiError): string | null {
  if (err.status === 400 && err.code === "INDUSTRY_REQUIRED") {
    return `${INDUSTRY_MISSING} The server will not create an organization without one.`;
  }
  if (err.status === 400 && err.code === "INDUSTRY_UNKNOWN") return INDUSTRY_NOT_ACCEPTED;
  if (err.status === 409 && (err.message ?? "").startsWith('Invalid industry "')) {
    return INDUSTRY_NOT_ACCEPTED;
  }
  return null;
}
